// @create-index
export { default as attachment } from './attachment.js';
export { default as bookmark } from './bookmark.js';
export { default as certifiedRibbon } from './certified-ribbon.js';
export { default as edit } from './edit.js';
export { default as link } from './link.js';
export { default as micOff } from './mic-off.js';
export { default as mic } from './mic.js';
export { default as pen } from './pen.js';
export { default as pencil } from './pencil.js';
export { default as search } from './search.js';
export { default as share } from './share.js';
export { default as trash } from './trash.js';
export { default as unlink } from './unlink.js';
//# sourceMappingURL=index.js.map